import {EntidadeNextGenService} from "./EntidadeNextGenService";

export class DocumentoTipoService extends EntidadeNextGenService {

	constructor() {
		super("/pessoas/documentos/tipos");
	}

}
